import moment from 'moment';

export const DATE_FORMAT_CHARS = 'DD/MM/YYYY';
export const DATE_FORMAT = '##/##/####';

export default function date(value = '', options = {}) {
  if (['', undefined, null].includes(value)) {
    return false;
  }

  const format = options.format || DATE_FORMAT_CHARS;

  if (moment(value, format, true).isValid()) {
    return false;
  }

  return true;
}

date.message = function message(value, options = {}) {
  return options.message || 'não é uma data válida';
};
